import React from "react";
import { CheckCircle2, AlertTriangle, Minus } from "lucide-react";

export const TallyBar = ({ totalVotes, validEntered }) => {
  const hasValid = validEntered > 0;
  const diff = totalVotes - validEntered;
  const pct = hasValid ? Math.min(100, Math.round((totalVotes / validEntered) * 100)) : 0;
  const state = !hasValid ? "idle" : diff === 0 ? "match" : "mismatch";
  const colors = state === "match" ? "border-emerald-500/50 bg-emerald-500/10 text-emerald-200"
    : state === "mismatch" ? "border-red-500/50 bg-red-500/10 text-red-200"
    : "border-white/15 bg-[#111114] text-zinc-400";
  const bar = state === "match" ? "bg-emerald-400" : state === "mismatch" ? (diff > 0 ? "bg-red-400" : "bg-amber-400") : "bg-zinc-600";
  const Icon = state === "match" ? CheckCircle2 : state === "mismatch" ? AlertTriangle : Minus;
  return (
    <div className={`border px-3 py-2 ${colors}`} data-testid="tally-bar" data-state={state}>
      <div className="flex items-center justify-between gap-3 text-[11px] uppercase tracking-[0.15em]">
        <div className="flex items-center gap-1.5"><Icon size={13}/>Votes vs valid ballots</div>
        <div className="tabular font-semibold text-sm normal-case tracking-normal" data-testid="tally-numbers">
          {totalVotes.toLocaleString()} <span className="opacity-60">/</span> {hasValid ? validEntered.toLocaleString() : "—"}
        </div>
      </div>
      <div className="mt-1.5 h-1.5 bg-black/40 relative overflow-hidden">
        <div className={`absolute inset-y-0 left-0 transition-[width] duration-300 ${bar}`} style={{ width: `${hasValid ? pct : 0}%` }}/>
      </div>
      <div className="mt-1 text-[11px]" data-testid="tally-message">
        {state === "idle" && "Enter valid ballots to check the sum."}
        {state === "match" && "Candidate votes equal valid ballots."}
        {state === "mismatch" && (diff > 0 ? `${diff.toLocaleString()} more votes than valid ballots` : `${Math.abs(diff).toLocaleString()} fewer votes than valid ballots`)}
      </div>
    </div>
  );
};
